"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateEdit = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const roundMoney_1 = require("../../../utils/roundMoney");
const Button_1 = require("../../Button");
const CheckBox_1 = require("../../CheckBox");
const Field_1 = require("../../Form/Field");
const legacy_1 = require("../../Form/Field/Select/legacy");
const Icon_1 = require("../../Icon");
const tariffGroupMapper_1 = require("../../TariffsTable/tariffGroupMapper");
const TariffTable_1 = require("../../TariffTable");
const ValidationErrors_1 = require("../../ValidationErrors");
require("./index.scss");
const className = 'rate-edit-form';
const PriceHint = (props) => {
    const { price, percent } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const priceNumber = !price || isNaN(price) ? 0 : parseFloat(price);
    const percentNumber = !percent || isNaN(percent) ? 0 : parseFloat(percent);
    const amount = priceNumber * percentNumber / 100;
    const roundedAmount = (0, roundMoney_1.roundMoney)(amount);
    const roundedPrice = (0, roundMoney_1.roundMoney)(percentNumber);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (0, roundMoney_1.localizeMoney)(roundedPrice, locale, 'Rate/Edit/PriceHint/price'),
        " * ",
        percentNumber,
        "% = ",
        (0, roundMoney_1.localizeMoney)(roundedAmount, locale, 'Rate/Edit/PriceHint/amount'),
        " CHF"));
};
class RateEditClass extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.handleSubmitButton = (event) => {
            event.preventDefault();
            const { rateData, } = this.state;
            this.props.onSubmit({
                rateData,
            });
        };
        this.handleFormStringInputChange = (event) => {
            const { target } = event;
            const { name, value, } = target;
            this.setState({
                rateData: {
                    ...this.state.rateData,
                    [name]: value !== '' ? value : undefined,
                },
            });
        };
        this.handleFormCheckboxInputChange = (event) => {
            const { target } = event;
            const { name, checked, } = target;
            this.setState({
                rateData: {
                    ...this.state.rateData,
                    [name]: checked,
                },
            });
        };
        this.handlePriceListItemInput = (event, tariff) => {
            var _a;
            const { target } = event;
            const { name, value } = target;
            const matchedItem = this.state.rateData.priceList.filter((priceListItem) => {
                return tariff.id === priceListItem.tariff.id;
            }).pop();
            const priceList = matchedItem !== undefined
                ? this.state.rateData.priceList.map((priceListItem) => {
                    if (tariff.id !== priceListItem.tariff.id) {
                        return priceListItem;
                    }
                    return { ...priceListItem, [name]: value !== '' ? value : undefined };
                })
                : [
                    ...(_a = this.state.rateData.priceList) !== null && _a !== void 0 ? _a : [],
                    { tariff, [name]: value !== '' ? value : undefined },
                ];
            this.setState({
                rateData: {
                    ...this.state.rateData,
                    priceList,
                },
            });
        };
        this.handleAddOptionInput = (event, tariff) => {
            var _a;
            const { target } = event;
            const { value } = target;
            const options = (_a = this.state.rateData.options) !== null && _a !== void 0 ? _a : [];
            const isOptionsExistsInTariff = options.filter(rateOption => { var _a; return ((_a = rateOption.tariff) === null || _a === void 0 ? void 0 : _a.id) === tariff.id && `${rateOption.option.id}` === value; }).length !== 0;
            const option = this.props.optionList.reduce((currentOption, x) => {
                return `${x.id}` === value ? x : currentOption;
            }, undefined);
            if (!option || isOptionsExistsInTariff)
                return;
            const newItem = { tariff, option };
            this.setState({
                rateData: {
                    ...this.state.rateData,
                    options: [...options, newItem],
                },
            });
        };
        this.handleRemoveTariffOption = (optionId, tariff) => {
            var _a, _b;
            const options = (_b = (_a = this.state.rateData) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.filter((rateOption) => {
                var _a;
                return !(((_a = rateOption.tariff) === null || _a === void 0 ? void 0 : _a.id) === tariff.id && rateOption.option.id === optionId);
            });
            this.setState({
                rateData: {
                    ...this.state.rateData,
                    options,
                },
            });
        };
        this.getFormError = (fieldName) => {
            return (0, ValidationErrors_1.getFormError)(this.props.formErrors, fieldName);
        };
        this.getFormRequired = (fieldName) => {
            return this.props.requiredFields.indexOf(fieldName) !== -1 ? ['required'] : [];
        };
        this.getFieldLabelClassNames = (fieldName) => {
            const labelClassName = `${className}__field-label`;
            const modificators = [...this.getFormRequired(fieldName)];
            return (0, classFunctions_1.getClassNames)(labelClassName, modificators);
        };
        this.getPriceListItemValue = (name, tariff) => {
            var _a;
            const matchPriceListItem = (_a = this.state.rateData.priceList) === null || _a === void 0 ? void 0 : _a.filter(priceListItem => tariff.id === priceListItem.tariff.id).pop();
            const value = matchPriceListItem && name in matchPriceListItem ? matchPriceListItem[name] : undefined;
            return value !== null && value !== void 0 ? value : '';
        };
        const rateData = props.rateData || RateEditClass.defaultProps.rateData;
        const priceList = props.tariffList.map((tariff) => {
            var _a;
            const matchPriceListItem = (_a = rateData === null || rateData === void 0 ? void 0 : rateData.priceList) === null || _a === void 0 ? void 0 : _a.filter(priceListItem => priceListItem.tariff.id === tariff.id).pop();
            return matchPriceListItem || {
                tariff,
                priceStandard: undefined,
                priceRound: undefined,
                priceChildPercent: undefined,
                priceInfantPercent: undefined,
                airportFee: undefined,
                fuelFee: undefined,
            };
        });
        this.state = {
            // @ts-ignore because of default undefined is not compatible with schema TODO think about removing ignore
            rateData: { ...rateData, priceList },
        };
    }
    render() {
        var _a, _b;
        const { tariffList, intl: { locale }, isSubmitButtonDisable, modificators } = this.props;
        const { rateData } = this.state;
        const optionList = [
            {
                name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:AddOption', defaultMessage: 'Add option' })),
                value: '',
            },
            ...this.props.optionList.map(option => ({
                name: option.code,
                value: `${option.id}`,
            })),
        ];
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("div", { className: `${className}__form-row` },
                    react_1.default.createElement("div", { className: `${className}__form-field` },
                        react_1.default.createElement(Field_1.FormField, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:fieldName', defaultMessage: 'Name' }), modificators: this.getFormRequired('name'), name: 'name', error: this.getFormError('name'), onChange: this.handleFormStringInputChange, value: (_a = rateData.name) !== null && _a !== void 0 ? _a : '' }))),
                react_1.default.createElement("div", { className: `${className}__tariffs` },
                    react_1.default.createElement(TariffTable_1.TariffTable, { rows: [[
                                {
                                    content: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:PriceTarif', defaultMessage: 'Price / Tariff' })),
                                },
                                ...tariffList === null || tariffList === void 0 ? void 0 : tariffList.map((tariff) => {
                                    var _a;
                                    return ({
                                        tariff: (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff.group.id),
                                        content: (react_1.default.createElement(react_1.default.Fragment, null, (_a = tariff.name[locale]) !== null && _a !== void 0 ? _a : tariff.name[Object.keys(tariff.name)[0]])),
                                    });
                                }),
                            ], [
                                {
                                    content: (react_1.default.createElement("div", { className: this.getFieldLabelClassNames('priceList/priceStandard') },
                                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:PriceStandardLabel', defaultMessage: 'Price standard (Fees are not included)' }))),
                                },
                                ...tariffList === null || tariffList === void 0 ? void 0 : tariffList.map((tariff, index) => {
                                    const value = this.getPriceListItemValue('priceStandard', tariff);
                                    const airportFee = this.getPriceListItemValue('airportFee', tariff);
                                    const fuelFee = this.getPriceListItemValue('fuelFee', tariff);
                                    const valueWithFees = Number(value) + Number(airportFee) + Number(fuelFee);
                                    return ({
                                        tariff: (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff.group.id),
                                        content: (react_1.default.createElement("div", { className: `${className}__field` },
                                            react_1.default.createElement(Field_1.FormField, { name: 'priceStandard', value: this.getPriceListItemValue('priceStandard', tariff), onChange: event => this.handlePriceListItemInput(event, tariff), error: this.getFormError(`/priceList/${index}/priceStandard`), modificators: this.getFormRequired('priceList/priceStandard'), addon: 'CHF' }),
                                            react_1.default.createElement("div", { className: `${className}__fees` },
                                                react_1.default.createElement("div", { className: `${className}__fees-title` },
                                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:IncludingFeesTitle', defaultMessage: 'Including fees' })),
                                                react_1.default.createElement("div", { className: `${className}__fees-value` },
                                                    (0, roundMoney_1.localizeMoney)((0, roundMoney_1.roundMoney)(valueWithFees), locale, 'Rate/Edit/valueWithFees'),
                                                    " CHF")))),
                                    });
                                }),
                            ], [
                                {
                                    content: (react_1.default.createElement("div", { className: this.getFieldLabelClassNames('priceList/priceRound') },
                                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:PriceRoundLabel', defaultMessage: 'Price round (Fees are not included)' }))),
                                },
                                ...tariffList === null || tariffList === void 0 ? void 0 : tariffList.map((tariff, index) => {
                                    const value = this.getPriceListItemValue('priceRound', tariff);
                                    const airportFee = this.getPriceListItemValue('airportFee', tariff);
                                    const fuelFee = this.getPriceListItemValue('fuelFee', tariff);
                                    const valueWithFees = Number(value) + Number(airportFee) + Number(fuelFee);
                                    return ({
                                        tariff: (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff.group.id),
                                        content: (react_1.default.createElement("div", { className: `${className}__field` },
                                            react_1.default.createElement(Field_1.FormField, { name: 'priceRound', value: this.getPriceListItemValue('priceRound', tariff), onChange: event => this.handlePriceListItemInput(event, tariff), error: this.getFormError(`/priceList/${index}/priceRound`), modificators: this.getFormRequired('priceList/priceRound'), addon: 'CHF' }),
                                            react_1.default.createElement("div", { className: `${className}__fees` },
                                                react_1.default.createElement("div", { className: `${className}__fees-title` },
                                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:IncludingFeesTitle', defaultMessage: 'Including fees' })),
                                                react_1.default.createElement("div", { className: `${className}__fees-value` },
                                                    (0, roundMoney_1.localizeMoney)((0, roundMoney_1.roundMoney)(valueWithFees), locale, 'Rate/Edit/valueWithFees'),
                                                    " CHF")))),
                                    });
                                }),
                            ], [
                                {
                                    content: (react_1.default.createElement("div", { className: this.getFieldLabelClassNames('priceList/priceChildPercent') },
                                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:PriceChild', defaultMessage: 'Price child' }))),
                                },
                                ...tariffList === null || tariffList === void 0 ? void 0 : tariffList.map((tariff, index) => {
                                    const percent = this.getPriceListItemValue('priceChildPercent', tariff);
                                    const standardPrice = this.getPriceListItemValue('priceStandard', tariff);
                                    const roundPrice = this.getPriceListItemValue('priceRound', tariff);
                                    return {
                                        tariff: (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff.group.id),
                                        content: (react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement("div", { className: `${className}__field` },
                                                react_1.default.createElement(Field_1.FormField, { name: 'priceChildPercent', value: percent, onChange: event => this.handlePriceListItemInput(event, tariff), error: this.getFormError(`/priceList/${index}/priceChildPercent`), info: [
                                                        react_1.default.createElement(react_1.default.Fragment, null,
                                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:PriceStandard', defaultMessage: 'Price standard' }),
                                                            ":",
                                                            react_1.default.createElement(PriceHint, { price: standardPrice, percent: percent }),
                                                            react_1.default.createElement("br", null),
                                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:PriceRound', defaultMessage: 'Price round' }),
                                                            ":",
                                                            react_1.default.createElement(PriceHint, { price: roundPrice, percent: percent })),
                                                    ], modificators: this.getFormRequired('priceList/priceChildPercent'), addon: '%' })))),
                                    };
                                }),
                            ], [
                                {
                                    content: (react_1.default.createElement("div", { className: this.getFieldLabelClassNames('priceList/priceInfantPercent') },
                                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:PriceBaby', defaultMessage: 'Price baby' }))),
                                },
                                ...tariffList === null || tariffList === void 0 ? void 0 : tariffList.map((tariff, index) => {
                                    const percent = this.getPriceListItemValue('priceInfantPercent', tariff);
                                    const standardPrice = this.getPriceListItemValue('priceStandard', tariff);
                                    const roundPrice = this.getPriceListItemValue('priceRound', tariff);
                                    return {
                                        tariff: (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff.group.id),
                                        content: (react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement("div", { className: `${className}__field` },
                                                react_1.default.createElement(Field_1.FormField, { name: 'priceInfantPercent', value: percent, onChange: event => this.handlePriceListItemInput(event, tariff), error: this.getFormError(`/priceList/${index}/priceInfantPercent`), info: [
                                                        react_1.default.createElement(react_1.default.Fragment, null,
                                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:PriceStandard', defaultMessage: 'Price standard' }),
                                                            ":",
                                                            react_1.default.createElement(PriceHint, { price: standardPrice, percent: percent }),
                                                            react_1.default.createElement("br", null),
                                                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:PriceRound', defaultMessage: 'Price round' }),
                                                            ":",
                                                            react_1.default.createElement(PriceHint, { price: roundPrice, percent: percent })),
                                                    ], modificators: this.getFormRequired('priceList/priceInfantPercent'), addon: '%' })))),
                                    };
                                }),
                            ], [
                                {
                                    content: (react_1.default.createElement("div", { className: this.getFieldLabelClassNames('priceList/airportFee') },
                                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:AirportFee', defaultMessage: 'Airport fee' }))),
                                },
                                ...tariffList === null || tariffList === void 0 ? void 0 : tariffList.map((tariff, index) => ({
                                    tariff: (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff.group.id),
                                    content: (react_1.default.createElement("div", { className: `${className}__field` },
                                        react_1.default.createElement(Field_1.FormField, { name: 'airportFee', value: this.getPriceListItemValue('airportFee', tariff), onChange: event => this.handlePriceListItemInput(event, tariff), error: this.getFormError(`/priceList/${index}/airportFee`), modificators: this.getFormRequired('priceList/airportFee'), addon: 'CHF' }))),
                                })),
                            ], [
                                {
                                    content: (react_1.default.createElement("div", { className: this.getFieldLabelClassNames('priceList/fuelFee') },
                                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:FuelFee', defaultMessage: 'Fuel fee' }))),
                                },
                                ...tariffList === null || tariffList === void 0 ? void 0 : tariffList.map((tariff, index) => ({
                                    tariff: (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff.group.id),
                                    content: (react_1.default.createElement("div", { className: `${className}__field` },
                                        react_1.default.createElement(Field_1.FormField, { name: 'fuelFee', value: this.getPriceListItemValue('fuelFee', tariff), onChange: event => this.handlePriceListItemInput(event, tariff), error: this.getFormError(`/priceList/${index}/fuelFee`), modificators: this.getFormRequired('priceList/fuelFee'), addon: 'CHF' }))),
                                })),
                            ]] })),
                react_1.default.createElement("div", { className: `${className}__options` },
                    react_1.default.createElement(TariffTable_1.TariffTable, { rows: [[
                                {
                                    content: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:OptionsTarif', defaultMessage: 'Options / Tariff' })),
                                },
                                ...tariffList === null || tariffList === void 0 ? void 0 : tariffList.map((tariff) => {
                                    var _a;
                                    return ({
                                        tariff: (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff.group.id),
                                        content: (react_1.default.createElement(react_1.default.Fragment, null, (_a = tariff.name[locale]) !== null && _a !== void 0 ? _a : tariff.name[Object.keys(tariff.name)[0]])),
                                    });
                                }),
                            ], [
                                '',
                                ...tariffList === null || tariffList === void 0 ? void 0 : tariffList.map((tariff) => {
                                    var _a, _b;
                                    const tariffOptionsIds = ((_b = (_a = rateData.options) === null || _a === void 0 ? void 0 : _a.filter(rateOption => { var _a; return ((_a = rateOption.tariff) === null || _a === void 0 ? void 0 : _a.id) === tariff.id; })) === null || _b === void 0 ? void 0 : _b.map(rateOption => `${rateOption.option.id}`)) || [];
                                    const filteredOptionList = optionList.filter(({ name, value }) => {
                                        return !tariffOptionsIds.includes(value);
                                    });
                                    return {
                                        tariff: (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff.group.id),
                                        content: (react_1.default.createElement("div", { className: `${className}__field` },
                                            react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { value: '', items: filteredOptionList, onChange: event => this.handleAddOptionInput(event, tariff) }))),
                                    };
                                }),
                            ], [
                                '',
                                ...tariffList === null || tariffList === void 0 ? void 0 : tariffList.map((tariff) => {
                                    var _a, _b;
                                    const tariffOptionsIds = ((_b = (_a = rateData.options) === null || _a === void 0 ? void 0 : _a.filter(rateOption => { var _a; return ((_a = rateOption.tariff) === null || _a === void 0 ? void 0 : _a.id) === tariff.id; })) === null || _b === void 0 ? void 0 : _b.map(rateOption => `${rateOption.option.id}`)) || [];
                                    const tariffOptions = this.props.optionList.filter((option) => {
                                        return tariffOptionsIds.includes(`${option.id}`);
                                    });
                                    return {
                                        tariff: (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff.group.id),
                                        content: (react_1.default.createElement("div", { className: `${className}__tariff-options` }, tariffOptions === null || tariffOptions === void 0 ? void 0 : tariffOptions.map((option, optionIndex) => (react_1.default.createElement("div", { className: `${className}__tariff-option`, key: optionIndex },
                                            react_1.default.createElement("span", { className: `${className}__tariff-option-text` }, option.code),
                                            react_1.default.createElement("span", { className: `${className}__tariff-option-remove`, onClick: () => this.handleRemoveTariffOption(option.id, tariff) },
                                                react_1.default.createElement(Icon_1.Icon, { name: 'x' }))))))),
                                    };
                                }),
                            ]] })),
                react_1.default.createElement("div", { className: `${className}__form-row` },
                    react_1.default.createElement("div", { className: `${className}__form-field   ` },
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Edit:Active', defaultMessage: 'Active' }), modificators: this.getFormRequired('isActive'), name: 'isActive', error: this.getFormError('isActive'), onChange: this.handleFormCheckboxInputChange, checked: (_b = rateData.isActive) !== null && _b !== void 0 ? _b : false }))),
                react_1.default.createElement("div", { className: `${className}__button` },
                    react_1.default.createElement(Button_1.Button, { icon: 'save', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option:Save', defaultMessage: 'Save' }), type: 'submit', onClick: this.handleSubmitButton, disabled: isSubmitButtonDisable })))));
    }
}
RateEditClass.defaultProps = {
    rateData: {
        id: 0,
        name: undefined,
        isActive: true,
        priceList: [],
        options: [],
    },
    tariffList: [],
    optionList: [],
    requiredFields: [],
    formErrors: {},
    onSubmit: () => {
    },
    isSubmitButtonDisable: false,
};
exports.RateEdit = (0, react_intl_1.injectIntl)(RateEditClass);
//# sourceMappingURL=index.js.map